import React, { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { MdOutlineClose, MdOutlineCheck, MdOutlineRefresh, MdOutlineSearch } from "react-icons/md";
import { Input, Button } from "react-daisyui"
import { useCategoryStore, CategoryStore, CategoryStoreContext } from "./store/CategoryStore";
import { observer } from "mobx-react";

const AddCategoryManagement = observer(() => {
    const store = new CategoryStore({
        isloadingtype:true,
        isloading:false,
        editloading:false
      });
    return (
        <CategoryStoreContext.Provider value={store}>
            <Screen />
        </CategoryStoreContext.Provider>
    )
})

export default AddCategoryManagement;

const Screen = observer(() => {
    const { 
        saved,
        loadCategory,
        image,
        ProductType,
        imageurl,
        setname,
        setstatus,
        setkeywords,
        setimage,
        addcategory,
        setProductType,
        setprice,
        setcheckbox,

        price,
        Producttypelist,
        addedloadcategory
      } = useCategoryStore();

      const navigate = useNavigate();
      useEffect(() => {
        if (saved) {
          navigate("../categorymanagement");
        }
      }, [saved,loadCategory]);
      const handleCheckboxChange = (e) => {
        const value = e.target.checked ? 1 : 0;
        setcheckbox(value);
      };
    return (
        <>
        <div className='flex justify-between'>
            <div className=" mb-4">
                <p className=" text-2xl font-semibold text-moredarkgreen">Add Category</p>
                {/* <p className=" opacity-80 text-sm">Home /City/ Edit</p> */}
            </div>
            <div>
                <Link to="/categorymanagement" className="btn btn-sm bg-darkgreen text-yellow text-sm hover:bg-yellow hover:text-darkgreen ">Back</Link>
            </div>
        </div>  
            <div className="card bg-base-100 shadow-md p-6 mt-3 mb-10">
                <form onSubmit={(e) => {addcategory();e.preventDefault() }}>
                <div className="grid lg:grid-cols-3 md:grid-cols-2 md:gap-8 gap-4">
                        <div>
                            <label htmlFor="ProductType" className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2">Type<span className="text-[#f00]">&nbsp;*</span></label>
                            <select
                                required
                                id="ProductType"
                                name="ProductType"
                                defaultValue=""
                                onChange={(e)=> {setProductType(e.target.value);setprice("");} }
                                className={`select focus:outline-0 w-full text-sm font-medium rounded-md focus:outline-offset-0 select-bordered`}>
                                <option value="" hidden className="">Select Product Type</option>
                                {Producttypelist && Producttypelist.map((res,index)=> (
                                    <option key={index} value={res?.id}>{res?.name}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label htmlFor="name" className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2">Name<span className="text-[#f00]">&nbsp;*</span></label>
                            <Input
                                required
                                name="name"
                                placeholder="Name"
                                onChange={(e)=> {setname(e.target.value)}}
                                id="name"
                                type="text"
                                autoComplete="off"
                                className="focus:outline-0 w-full text-sm font-medium rounded-md"
                            />
                        </div>
                        <div>
                            <label htmlFor="keywords" className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2">Keywords<span className="text-[#f00]">&nbsp;*</span></label>
                            <Input
                                name="keywords"
                                required
                                placeholder="keywords"
                                onChange={(e)=> {setkeywords(e.target.value)}}
                                id="keywords"
                                type="text"
                                autoComplete="off"
                                className="focus:outline-0 w-full text-sm font-medium rounded-md"
                            />
                        </div>
                        <div>
                            <label htmlFor="Price" className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2">Price<span className="text-[#f00]">&nbsp;*</span></label>
                            <Input
                                required
                                disabled={ProductType === "3" || ProductType === "4"  ? false : true}
                                name="Price"
                                placeholder="Price"
                                min="0.1"
                                title="Value must be greater than 0.1"
                                id="name"
                                type="number"
                                step="any"
                                value={price}
                                onChange={(e)=> {setprice(e.target.value)}}
                                autoComplete="off"
                                className="focus:outline-0 w-full text-sm font-medium rounded-md"
                            />
                        </div>
                        <div>
                            <label htmlFor="Status" className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2">Status<span className="text-[#f00]">&nbsp;*</span></label>
                            <select
                                id="Status"
                                required
                                name="Status"
                                onChange={(e)=> {setstatus(e.target.value)}}
                                className={`select focus:outline-0 w-full text-sm font-medium rounded-md focus:outline-offset-0 select-bordered`}>
                                <option value="" disabled selected className="hidden">Select Status</option>
                                <option value="1">Active</option>
                                <option value="0">Inactive </option>
                            </select>
                        </div>
                        <div>
                            <label htmlFor="image" className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2">File<span className="text-[#f00]">&nbsp;*</span></label>
                            <div className=" grid grid-cols-3">
                            <Input
                                name="image"
                                required
                                placeholder="Image"
                                accept={ProductType == "2" ? "audio/*" : ".jpg, .png"}
                                onChange={(e)=> {setimage(e.target.files)}}
                                type="file"
                                autoComplete="off"
                                className="focus:outline-0 w-full text-sm font-medium rounded-md col-span-2"
                            />
                            <img className="w-full" src={imageurl}/>
                            </div>
                        </div>
                        <div>
                            <label htmlFor="checkbox" className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2">Popular Category</label>
                            <div className=" grid grid-cols-3">
                            <Input
                                name="checkbox"
                                id="checkbox"
                                // defaultValue=""
                                onChange={handleCheckboxChange}
                                type="checkbox"
                                autoComplete="off"
                                className="focus:outline-0 w-5 h-5 text-sm font-medium rounded-md "
                            />
                            </div>
                        </div>
                    </div>
                    <div className="lg:mt-3 mt-4 flex items-center md:justify-end justify-between">
                        <Link to="/categorymanagement" className="btn btn-md bg-darkgreen text-[#fff] text-sm hover:text-darkgreen hover:bg-lightgreen "><MdOutlineClose className="mr-1"/>Cancel</Link>

                        {   
                        !addedloadcategory ?
                        <button type="submit"  className="btn btn-md bg-lightgreen text-darkgreen text-sm hover:bg-darkgreen hover:text-[#fff]   ml-4" ><MdOutlineCheck className="mr-1"/>Add Category</button>
                        :
                        <button 
                        className="btn btn-md opacity-80 bg-lightgreen text-darkgreen text-sm hover:bg-darkgreen hover:text-[#fff]   ml-4"
                          type="button"
                        //  onClick={()=> changeStep("4")}
                        >
                        <svg
                            className="animate-spin mr-1 h-5 w-5 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            >
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                        </svg>
                          Loading..
                        </button>
                        }
                    </div>
                </form>
            </div>

        </>
    )
})
